import { z } from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema, ObjectIdString } from '../common.js';

export const IAuthAccount = z.object({
  _id: ObjectIdSchema,
  user: objectIdRef('AuthUser'),
  providerId: z.string(),
  providerAccountId: z.string(),
  idToken: z.string().nullish(),
  accessToken: z.string().nullish(),
  refreshToken: z.string().nullish(),
  accessTokenExpiresAt: DateTimeSchema.nullish(),
  refreshTokenExpiresAt: DateTimeSchema.nullish(),
  scope: z.string().nullish(),

  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IAuthAccount = z.infer<typeof IAuthAccount>;

export const IAuthSession = z.object({
  _id: ObjectIdSchema,
  user: objectIdRef('AuthUser'),
  token: z.string(),
  ipAddress: z.string().nullish(),
  userAgent: z.string().nullish(),
  expiresAt: DateTimeSchema,
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,

  // Added by the admin plugin
  impersonatedBy: ObjectIdString.nullish(),
});
export type IAuthSession = z.infer<typeof IAuthSession>;

export const IAuthVerification = z.object({
  _id: ObjectIdSchema,
  identifier: z.string(),
  value: z.string(),
  expiresAt: DateTimeSchema,
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IAuthVerification = z.infer<typeof IAuthVerification>;
